// La panchina delle partite non assegnate.
//
// E' il turno 0, dove il campo fa da numero di posto. Turni e campi veri partono da 1, quindi lo
// zero e' libero e il server puo' registrare lo spostamento senza colonne nullabili (turno e campo
// di partenza stanno nella chiave della tabella delle modifiche).
//
// Serve una coordinata vera perche' una partita e' identificata dalla sua posizione: con "nessuna
// posizione" - il null che il frontend mandava prima, e che faceva morire la richiesta con un 400
// perche' il DTO ha degli int - due partite in panchina sarebbero indistinguibili, e non si
// potrebbe rimetterne in campo una in particolare.
export const TURNO_PANCHINA = 0;

/** Il primo posto libero in panchina. */
export const postoLiberoInPanchina = (inPanchinaOra) => {
  const presi = new Set(inPanchinaOra.map((m) => m.campo));
  let posto = 1;
  while (presi.has(posto)) posto += 1;
  return posto;
};

/** Una partita messa in panchina perde l'arbitro: non ha piu' un turno in cui arbitrare. */
export const inPanchina = (match, posto) => ({
  ...match, turno: TURNO_PANCHINA, campo: posto, squadraA: null, idSA: null,
});

/** I posti da assegnare a piu' partite che finiscono in panchina insieme, tutti distinti. */
export const postiPerTutte = (daMettere, giaInPanchina) => {
  const occupati = [...giaInPanchina];
  return daMettere.map((match) => {
    const posto = postoLiberoInPanchina(occupati);
    occupati.push({ campo: posto });
    return inPanchina(match, posto);
  });
};
